import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Platform charge amount fee.
 */
export const schema = z.number().nonnegative();

export type PlatformChargeAmount = z.infer<typeof schema>;

export const definition = define({
  key: 'platform_charge_amount',
  schema,
  label: 'Platform Charge Amount',
  description: 'Platform charge amount applied to moves at this level.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 0.75,
});
